import React, { useState, useEffect } from 'react';
import QuarterDetails from '@components/templates/pursuitLeader/dashboard/quarterlyDetails';
import YearlyMetrics from '@components/templates/pursuitLeader/dashboard/yearlyMetrics';
import PersonalDashboard from '@components/templates/pursuitLeader/dashboard/personalDashboard';
import DashboardAlerts from '@components/organisms/alertBar/dashboardAlerts';
import SpinnerLoader from '@components/atoms/SpinnerLoader';
import DateTimePicker from '@components/atoms/datePicker/dateTimePicker';
import {
  DashboardWrapper,
  CenteredSpinner,
  DashboardContainer,
  DashboardTitles,
  QuarterlyMatrixTitle,
} from '@pages/dashboard/dashboard.styles';
import { PAGES, DASHBOARD_PAGE_TITLE } from '@constants/commonConstants';

const screenName = PAGES.DASHBOARD;

const PlDashboard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <DashboardWrapper>
      {loading ? (
        <CenteredSpinner>
          <SpinnerLoader color="#155CB4" />
        </CenteredSpinner>
      ) : null}
      <DashboardAlerts screenName={screenName} />
      <DashboardContainer>
        {!loading ? (
          <>
            <DashboardTitles>
              {DASHBOARD_PAGE_TITLE.MY_DASHBOARD}
              <DateTimePicker />
            </DashboardTitles>
            <PersonalDashboard />
            <QuarterlyMatrixTitle>{DASHBOARD_PAGE_TITLE.QUARTERLY_METRICS}</QuarterlyMatrixTitle>
            <QuarterDetails />
            <QuarterlyMatrixTitle>{DASHBOARD_PAGE_TITLE.YEARLY_METRICS}</QuarterlyMatrixTitle>
            <YearlyMetrics />
          </>
        ) : null}
      </DashboardContainer>
    </DashboardWrapper>
  );
};

export default PlDashboard;
